
import { defineComponent, PropType } from 'vue'

enum Size {
  small = 'S',
  medium = 'M',
  large = 'L'
}

enum Color {
  white = 'white',
  black = 'black'
}

export default defineComponent({
  name: 'IconBtn',
  emits: ['icon-btn-clicked'],
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String as PropType<Size>,
      default: 'M'
    },
    color: {
      type: String as PropType<Color>,
      default: 'white'
    }
  }
})
